/* eslint-disable func-names */
// eslint-disable-next-line func-names
export const arrayMoveMutable = function <T> (
  array: T[],
  fromIndex: number,
  toIndex: number,
): void {
  const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

    const [item] = array.splice(fromIndex, 1);
    array.splice(endIndex, 0, item);
  }
};

export const arrayMoveImmutable = function <T> (
  array: T[],
  fromIndex: number,
  toIndex: number,
): T[] {
  const arr = [...array];
  arrayMoveMutable(arr, fromIndex, toIndex);
  return arr;
};
